import { print, parse } from 'graphql'

// tslint:disable

export function safely(cb: any) {
  return function*(...args) {
    try {
      yield cb(...args)
    } catch (e) {
      console.error(e)
    }
  }
}

export function prettify(query) {
  return print(parse(query))
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils.ts